"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbandonedSteelForge = void 0;
const Tags_1 = require("../../Tags");
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Resources_1 = require("../../../Resources");
class AbandonedSteelForge extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ABANDONED_STEEL_FORGE,
            metadata: {
                cardNumber: 'Y20',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.steel(9).br.br;
                    b.cards(2).secondaryTag(Tags_1.Tags.BUILDING);
                }),
                description: 'Gain 9 steel. Reveal cards until you reveal two cards with Building tags. Take them into your hand and discard the rest.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.STEEL, 9);
        player.drawCard(2, { tag: Tags_1.Tags.BUILDING });
        return undefined;
    }
    ;
}
exports.AbandonedSteelForge = AbandonedSteelForge;
//# sourceMappingURL=AbandonedSteelForge.js.map